function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icon/Big/NoSun");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "styleguide",
  transform: "translate(-587.000000, -855.000000)",
  fill: "#FD9872"
}, React.createElement("g", {
  id: "Icon/Big/NoSun",
  transform: "translate(581.000000, 849.000000)"
}, React.createElement("path", {
  d: "M10.7048,18.5961 L12.3698,19.7041 C9.5108,24.0001 7.9998,29.0121 7.9998,34.1961 C7.9998,48.6411 19.7518,60.3921 34.1958,60.3921 C39.6668,60.3921 44.9058,58.7241 49.3498,55.5671 L50.5078,57.1981 C45.7248,60.5961 40.0838,62.3921 34.1958,62.3921 C18.6488,62.3921 5.9998,49.7441 5.9998,34.1961 C5.9998,28.6171 7.6268,23.2221 10.7048,18.5961 Z M8.5959,7.1824 L61.2099,59.7964 C61.6009,60.1874 61.6009,60.8194 61.2099,61.2104 C61.0149,61.4054 60.7589,61.5034 60.5029,61.5034 C60.2469,61.5034 59.9909,61.4054 59.7959,61.2104 L7.1819,8.5964 C6.7909,8.2054 6.7909,7.5724 7.1819,7.1824 C7.5719,6.7914 8.2049,6.7914 8.5959,7.1824 Z M34.1957,5.9997 C49.7427,5.9997 62.3917,18.6487 62.3917,34.1967 C62.3917,39.9407 60.6757,45.4677 57.4277,50.1787 L55.7817,49.0437 C58.7977,44.6677 60.3917,39.5327 60.3917,34.1967 C60.3917,19.7517 48.6407,7.9997 34.1957,7.9997 C29.3267,7.9997 24.5747,9.3447 20.4537,11.8897 L19.4027,10.1877 C23.8397,7.4487 28.9557,5.9997 34.1957,5.9997 Z",
  id: "Combined-Shape"
}))));

var SvgNoAnswer = function SvgNoAnswer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "57px",
    height: "57px",
    viewBox: "0 0 57 57",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoAnswer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-answer.2969b761.svg";
export { ForwardRef as ReactComponent };